import { getApiUrl } from '@/api/apiClient';

export default {
  get: () => getApiUrl('/ping'),
};
